import { JSX, useEffect, useState } from "react";

import { WizardCustomer } from "models/wizard/WizardState";
import CustomerInformationSummary from "./CustomerInformationSummary";
import CustomerInformationEdit from "./CustomerInformationEdit";

type Props = {
  collapsed: boolean;
  customer: WizardCustomer;
  info?: string | JSX.Element;
};

export default function CustomerInformation({
  collapsed,
  customer,
  info
}: Props) {
  const [view, setView] = useState(collapsed ? "summary" : "edit");

  useEffect(() => {
    setView(collapsed ? "summary" : "edit");
  }, [collapsed]);

  const handleEditClick = () => {
    setView("edit");
  };

  const handleSaveClick = () => {
    setView("summary");
  };

  const viewContent =
    view === "summary" ? (
      <CustomerInformationSummary
        onEditClick={handleEditClick}
        customer={customer}
        info={info}
      />
    ) : (
      <CustomerInformationEdit
        showSaveButton={collapsed}
        onSaveClick={handleSaveClick}
        customer={customer}
        info={info}
      />
    );

  return <div>{viewContent}</div>;
}
